import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function AppLayout({ children }) {
  const { profile, signOut } = useAuth();
  const location = useLocation();

  const nav = [
    { to: "/suporte", label: "Início", match: (p) => p === "/suporte" },
    { to: "/suporte/chamados", label: "Chamados", match: (p) => p.startsWith("/suporte/chamados") },
    { to: "/suporte/cortesia", label: "Cortesia", match: (p) => p.startsWith("/suporte/cortesia") },
    {
      to: "/suporte/busca-mensagens",
      label: "Busca de mensagens",
      match: (p) => p.startsWith("/suporte/busca-mensagens"),
    },
  ];

  return (
    <div className="app-shell">
      <header className="app-shell-header">
        <div className="app-shell-brand">
          <div className="app-shell-logo" aria-hidden>
            L
          </div>
          <div>
            <h1>Suporte Linqer</h1>
            <p>{profile?.name || profile?.email || "Usuário autenticado"}</p>
          </div>
        </div>

        <nav className="app-shell-nav" aria-label="Navegação principal">
          {nav.map((item) => (
            <Link key={item.to} className={item.match(location.pathname) ? "active" : ""} to={item.to}>
              {item.label}
            </Link>
          ))}
        </nav>

        <button className="secondary-button app-shell-logout" onClick={signOut} type="button">
          Sair
        </button>
      </header>
      <main className="app-shell-content">{children}</main>
    </div>
  );
}
